class Exhibitors {
    constructor() {
        const form = document.getElementById('exhibitors-registration');
        // If contact_email hidden
        const contactEmail = document.getElementById('contact_email');
        const email = document.getElementById('email');
        if ((email && contactEmail) && contactEmail.getAttribute('type') === 'hidden') {
            email.addEventListener('change', () => {
                contactEmail.value = email.value;
            });
            if (form) {
                form.addEventListener('click', () => {
                    contactEmail.value = email.value;
                });
            }
        }
        // If commercial name hidden
        const commercialName = document.getElementById('commercial_name');
        const title = document.getElementById('title');
        if ((title && commercialName) && commercialName.getAttribute('type') === 'hidden') {
            title.addEventListener('change', () => {
                commercialName.value = title.value;
            });
            if (form) {
                form.addEventListener('click', () => {
                    commercialName.value = title.value;
                });
            }
        }
    }

    static toggleOtherField(value, extraAttribute) {
        extraAttribute.querySelector('.js-other-field').classList.add('hidden');
        if (value === 'other' && extraAttribute.querySelector('.js-other-field')) {
            extraAttribute.querySelector('.js-other-field').classList.remove('hidden');
        }
    }
}

export default Exhibitors;
